import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { SkillDetailsFragmentDoc } from '../../../../../../skill-matrix/graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserFeedbackSkillsQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type UserFeedbackSkillsQuery = { user?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, responsibilities?: Array<{ id: string, name: string, skills?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null, mindsets?: Array<{ __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null }> | null, orgRole?: { id: string, name: string } | null } | null };


export const UserFeedbackSkillsDocument = /*#__PURE__*/ gql`
    query userFeedbackSkills($filters: UserFilters!) {
  user(filters: $filters) {
    ...User
    responsibilities {
      id
      name
      skills {
        ...SkillDetails
      }
      mindsets {
        ...SkillDetails
      }
    }
  }
}
    ${UserFragmentDoc}
${SkillDetailsFragmentDoc}`;

export function useUserFeedbackSkillsQuery(options: Omit<Urql.UseQueryArgs<UserFeedbackSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserFeedbackSkillsQuery, UserFeedbackSkillsQueryVariables>({ query: UserFeedbackSkillsDocument, ...options });
};